export default "__VITE_ASSET__B0UfAbUE__"